<!-- Filled by renderRichText, never by interpolation or innerHTML: see the
     component for why the contents are built as DOM nodes. -->
<div
	#input
	class="rich-text"
	cdkOverlayOrigin
	#origin="cdkOverlayOrigin"
	[class.rich-text--editable]="editable"
	[class.rich-text--at-limit]="editing && atLimit"
	[attr.contenteditable]="editable ? 'true' : null"
	[attr.role]="editable ? 'textbox' : null"
	[attr.aria-label]="editable ? field?.label : null"
	[attr.aria-multiline]="editable ? 'true' : null"
	[attr.spellcheck]="editable ? 'true' : null"
	[attr.data-placeholder]="editable && placeholder ? placeholder : null"
	(focus)="onFocus()"
	(blur)="onBlur($event)"
	(keydown)="onKeydown($event)"
	(beforeinput)="onBeforeInput($event)"
	(input)="onInput()"
	(paste)="onPaste($event)"
	(drop)="onDrop($event)"
></div>

<!-- EDITOR ONLY: open while the reader is typing, which needs the editor. -->
<ng-template
	cdkConnectedOverlay
	[cdkConnectedOverlayOrigin]="origin"
	[cdkConnectedOverlayOpen]="editing"
	[cdkConnectedOverlayPositions]="toolbarPositions"
	[cdkConnectedOverlayScrollStrategy]="scrollStrategy"
>
	<div
		#toolbar
		class="rich-toolbar"
		role="toolbar"
		aria-label="Formatting"
		(mousedown)="keepSelection($event)"
	>
		<ng-container *ngIf="!linking; else linkForm">
			<button
				type="button"
				class="rich-toolbar__button"
				[class.rich-toolbar__button--on]="active.bold"
				[attr.aria-pressed]="active.bold"
				aria-label="Bold"
				[matTooltip]="hints.bold"
				matTooltipPosition="above"
				matTooltipClass="sentiment-tooltip"
				(click)="format('bold')"
			>
				<app-icon type="mat" [size]="18">format_bold</app-icon>
			</button>
			<button
				type="button"
				class="rich-toolbar__button"
				[class.rich-toolbar__button--on]="active.italic"
				[attr.aria-pressed]="active.italic"
				aria-label="Italic"
				[matTooltip]="hints.italic"
				matTooltipPosition="above"
				matTooltipClass="sentiment-tooltip"
				(click)="format('italic')"
			>
				<app-icon type="mat" [size]="18">format_italic</app-icon>
			</button>
			<button
				type="button"
				class="rich-toolbar__button"
				[class.rich-toolbar__button--on]="active.link"
				[attr.aria-pressed]="active.link"
				[attr.aria-label]="active.link ? 'Remove link' : 'Link'"
				[class.rich-toolbar__button--idle]="
					!active.link && !active.selection
				"
				[attr.aria-disabled]="!active.link && !active.selection"
				[matTooltip]="
					active.link
						? hints.unlink
						: active.selection
						? hints.link
						: hints.linkNeedsText
				"
				matTooltipPosition="above"
				matTooltipClass="sentiment-tooltip"
				(click)="toggleLink()"
			>
				<app-icon type="mat" [size]="18">
					{{ active.link ? 'link_off' : 'link' }}
				</app-icon>
			</button>
			<span class="rich-toolbar__divider"></span>
			<button
				type="button"
				class="rich-toolbar__button"
				[class.rich-toolbar__button--on]="active.bullets"
				[attr.aria-pressed]="active.bullets"
				aria-label="Bulleted list"
				[matTooltip]="hints.bullets"
				matTooltipPosition="above"
				matTooltipClass="sentiment-tooltip"
				(click)="format('insertUnorderedList')"
			>
				<app-icon type="mat" [size]="18">format_list_bulleted</app-icon>
			</button>
			<button
				type="button"
				class="rich-toolbar__button"
				[class.rich-toolbar__button--on]="active.numbers"
				[attr.aria-pressed]="active.numbers"
				aria-label="Numbered list"
				[matTooltip]="hints.numbers"
				matTooltipPosition="above"
				matTooltipClass="sentiment-tooltip"
				(click)="format('insertOrderedList')"
			>
				<app-icon type="mat" [size]="18">format_list_numbered</app-icon>
			</button>
		</ng-container>

		<ng-template #linkForm>
			<div class="rich-toolbar__link">
				<input
					#linkInput
					class="rich-toolbar__link-input"
					type="text"
					inputmode="url"
					placeholder="Paste a link, then press Enter"
					aria-label="Link address"
					[value]="linkValue"
					(input)="onLinkInput($event)"
					(keydown)="onLinkKeydown($event)"
					(blur)="onLinkBlur($event)"
				/>
				<span class="rich-toolbar__link-error" *ngIf="linkError">
					{{ linkError }}
				</span>
			</div>
		</ng-template>
	</div>
</ng-template>

<span
	*ngIf="showEdited && edited && !editing"
	class="rich-text__marker"
	matTooltip="You typed this. Ana keeps it unless you ask her to rewrite it."
	matTooltipPosition="above"
	matTooltipClass="sentiment-tooltip"
>
	Edited
</span>

<span *ngIf="editing && atLimit" class="rich-text__limit">
	{{ limit }} characters at most
</span>
